import { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { db } from "./firebase.utils";
import { setCurrentUser } from "../redux/user/user.actions";

export default function useChatPreferences() {
  const uid = useSelector((s) => s.user.currentUser?.uid);
  const dispatch = useDispatch();
  const store = useStore();
  useEffect(() => {
    if (!uid) return;
    let active = true;
    const stop = db.collection("users").doc(uid).onSnapshot((snapshot) => {
      const current = store.getState().user.currentUser;
      if (!active || !snapshot.exists || current?.uid !== uid) return;
      const data = snapshot.data();
      const preferences = {};
      for (const key of ["mutedUsers", "blockedUsers", "mutedChats"]) {
        preferences[key] = Array.isArray(data[key]) ? data[key] : [];
      }
      dispatch(setCurrentUser({ ...current, ...preferences }));
    }, (error) => console.error("Chat preferences:", error));
    return () => { active = false; stop(); };
  }, [uid, dispatch, store]);
}
